import React from "react";
import Header from "../header/Header";
// import "./ChatBot.css";
import styles from "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
} from "@chatscope/chat-ui-kit-react";
import { Constants } from "../../Constants";

const ChatBot = () => {
  return (
    <div className="containerChatbotUI">
      <MainContainer>
        <ChatContainer>
          <MessageList>
            <Message
              model={{
                message: Constants.INITIAL_MSG,
                sentTime: "just now",
                sender: "Joe",
              }}
            />
          </MessageList>
          <MessageInput placeholder="Type message here" attachButton={false} />
        </ChatContainer>
      </MainContainer>
    </div>
  );
};

export default ChatBot;
